import { Pipe, PipeTransform } from '@angular/core';
import { ProjectStatus } from '../types/project.interface';

export const PROJECT_STATUS_LABELS: Readonly<Record<ProjectStatus, string>> = {
  incomplete: 'Incomplete',
  complete: 'Complete',
  po_under_review: 'PO Under Review',
  po_approved: 'PO Approved',
  in_production: 'In Production',
  partially_shipped: 'Partially shipped',
  shipping: 'Shipping',
  delivered: 'Delivered',
  invoiced: 'Invoiced',
  paid: 'Paid',
};

const STATUS_LABELS: Readonly<Record<string, string>> = {
  ...PROJECT_STATUS_LABELS,
  installation: 'Installation',
  completed: 'Completed',
  complete_datasheet: 'Complete Datasheet',
  pending: 'Sent for Approval',
  approved: 'Approved',
};

@Pipe({
    name: 'statusLabel',
    standalone: false
})
export class StatusLabelPipe implements PipeTransform {

  transform(status: string | null | undefined): string {
    if (status == null || status === '') {
      return '';
    }

    return STATUS_LABELS[status] || this.toTitle(status);
  }

  private toTitle(value: string): string {
    return value
      .replaceAll('_', ' ')
      .replace(/\b\w/g, (part) => part.toUpperCase());
  }

}
